export interface TaxonomicGroup {
  id: string;
  order: string;
  class: string;
  family: string;
  genus: string;
  phylum: string;
  rein: string;
  species: string;
  createdAt: string;
  updatedAt: string;
}

export const taxonomicGroupColumns: Array<{
  id: keyof TaxonomicGroup;
  label: string;
}> = [
  {
    id: "rein",
    label: "Reino",
  },
  {
    id: "phylum",
    label: "Filo",
  },
  {
    id: "class",
    label: "Classe",
  },
  {
    id: "order",
    label: "Ordem",
  },
  {
    id: "family",
    label: "Família",
  },
  {
    id: "genus",
    label: "Gênero",
  },
  {
    id: "species",
    label: "Espécie",
  },
];
